export default "__VITE_ASSET__Dyy8EFLm__"